module.exports = __webpack_public_path__ + "static/JC_img-2bd999dd0e66a508bf158b69320f8a16.jpg";